import { Injectable } from '@angular/core';
import { BehaviorSubject, MonoTypeOperatorFunction, Observable } from 'rxjs';
import { FeatureType, HeaderSectionEnableEnum, Page, PageLevel, PageType, RendererType, Site, SiteEditorConfig, SiteMataData, SliderType } from '../editor-container/editor-model';
import { BannerLayoutEnum, BloglistLayoutEnum, GridLayoutEnum, ContainerLayouts, FontSizeClasses, FooterRendererType, InputType, HeadFootEnum, OrientationEnum, TestimonialLayoutEnum, ProductRowLayoutEnum, LinkType, GridCellClass, ContentEnum, ImageUrlEnum, ProductFeatureTypeEnum, ProductTypeEnum, GridCell, ContentElementEnum, VisibilityEnum, HeroLayoutEnum, VerticalAlignEnum } from '@urbannex/storethemes';
import { NavigationEnd, Router } from '@angular/router';
import { filter, map, take, tap } from 'rxjs/operators';
import { site1 } from './Site1';
import { site2 } from './Site2';
import { site3 } from './Site3';
import { site4 } from './Site4';
import { site5 } from './Site5';
import { site6 } from './Site6';
import { site7 } from './Site7';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SiteConfigListenerService {
  siteMetas: SiteMataData[] = [];
  sites: Site[] = [];
  public selectedSite: BehaviorSubject<Site> = new BehaviorSubject<Site>(null);
  // siteEditorConfigInit:SiteEditorConfig = {};
  public siteEditorSites: BehaviorSubject<Site[]> = new BehaviorSubject<Site[]>(null);
  private selectedPageType: BehaviorSubject<PageType> = new BehaviorSubject<PageType>(PageType.HOME);
  public isLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  // private screenWidth:Subject<number> = new BehaviorSubject<number>(1366);

  constructor(
    private router: Router,
    private ofbizForms: OfbizFormsService) {
    this.loadSites();

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      map((event: NavigationEnd) => event.url)
    )
      .subscribe(url => {
        console.log(url)
        const route = url.split('?')[0].split('/').pop()
        console.log(route);
        switch (route) {
          case "home-page":
            this.setSelectedPageType(PageType.HOME);
            // this.currentRoute = PageType.HOME;
            break;
          case "category-page":
            this.setSelectedPageType(PageType.PRODUCT_CATEGORY);
            break;
          // this.previewEditStoreService.updatePageType(PageType.PRODUCT_CATEGORY);
          case "product-page":
            this.setSelectedPageType(PageType.PRODUCT);
            break;
          // this.previewEditStoreService.updatePageType(PageType.PRODUCT_CATEGORY);
          case "cart":
            this.setSelectedPageType(PageType.CART);
            break;
          case "blog":
            this.setSelectedPageType(PageType.BLOGROOT);
            break;
          case "about-us":
            this.setSelectedPageType(PageType.ABOUT_US);
            break;
          case "policies":
            this.setSelectedPageType(PageType.STORE_POLICIES);
            break;
          default:
            this.setSelectedPageType(PageType.HOME);
            break;
        }
      });
  }

  loadSites() {
    this.ofbizForms.doGetWebSite("website/sites/121234")
      .pipe(
        take(1),
        map((resp) => {
          return this.siteMetas = resp["data"]["siteMetaDatas"];
        }),
        tap((siteMetas) => {
          let numberOfSites = 0
          siteMetas.forEach(meta => {
            const endpoint = "website/" + meta.siteId;
            this.ofbizForms.doGetWebSite(endpoint)
              .pipe(take(1))
              .subscribe(resp => {
                const site = (resp["data"]);
                console.log(site);
                const keeper = _.cloneDeep(site);
                site.pages.splice(0, site.pages.length);
                keeper.pages.forEach(page => {
                  site.pages.push(new Page(page));
                })
                this.sites.push(site);
                numberOfSites++;
                // this.siteEditorConfigInit.sites.push(site);
              })

          });
          console.log({ retrievedSites: numberOfSites, siteLength: this.sites.length })
          if (numberOfSites === this.sites.length) {
            console.log("fournd equality")
            // this.siteEditorConfigInit.sites = this.sites;
            this.selectedSite.next(this.sites[0]);
            /**
           * Populate the initial siteCofig
           */
            this.siteEditorSites.next(this.sites);
            /**
             * Set loaded to true to confirm sites have been loaded
             */
            this.isLoaded.next(true);
          }

        })).subscribe();
    /* .subscribe(resp => {
      if(resp["data"] != undefined){
        let siteMetaDatas = resp["data"]["siteMetaDatas"];
        if(siteMetaDatas != undefined){
          this.siteMetas = siteMetaDatas;
          if(this.siteMetas.length > 0){
            //this.loadSite(this.siteMetas[0].siteId);
            let numberOfSites = 0
            this.siteMetas.forEach(meta => {
                let endpoint = "website/"+meta.siteId;
                this.ofbizForms.doGetWebSite(endpoint)
                .pipe(take(1))
                .subscribe(resp => {
                  let site = (resp["data"]);
                  console.log(site);
                  let keeper = _.cloneDeep(site);
                  site.pages.splice(0,site.pages.length);
                  keeper.pages.forEach(page => {
                    site.pages.push(new Page(page));
                  })
                  this.sites.push(site);
                  numberOfSites ++;
                })

              });
          console.log({retrievedSites:numberOfSites,siteLength:this.sites.length})
          if(numberOfSites === this.sites.length){
            console.log("fournd equality")
            this.selectedSite.next(this.sites[0]);
            this.siteEditorSites.next(this.sites);
            this.isLoaded.next(true);
          }
        }

        }

      }
    }) */

  }

  initSiteEditorConfig(): Observable<Site[]> {
    return this.siteEditorSites.asObservable();
  }

  setSelectedPageType(pageType: PageType) {
    console.log("Track selected Page: " + pageType);
    this.selectedPageType.next(pageType);
  }

  getSelectedPageType(): Observable<PageType> {
    return this.selectedPageType.asObservable();
  }

  getSiteMetas(): any[] {
    /* let siteMetaData:any = [];
    this.siteEditorConfig.subscribe((siteConfigs:SiteEditorConfig) => {
     if(siteConfigs != undefined){
      siteConfigs.sites.forEach(site => {
        let siteMeta = {siteName:"",siteId:"",themeName:""};
        siteMeta.siteName = site.siteName;
        siteMeta.siteId = site.siteId;
        siteMeta.themeName = site.theme.name;
        siteMetaData.push(siteMeta);
      })
     }
    })
    console.log(siteMetaData); */
    return this.siteMetas;

  }

  /* loadSite(id:string):void{
    let endpoint = "website/"+id;
    this.ofbizForms.doGetWebSite(endpoint)
    .pipe(take(1))
    .subscribe(resp => {
      let site = (resp["data"]);
      //site.theme.name="default";
      console.log(site);
      let keeper = _.cloneDeep(site);
      site.pages.splice(0,site.pages.length);
      keeper.pages.forEach(page => {
        site.pages.push(new Page(page));
      })
      this.siteEditorConfigInit.sites.push(site);
    })
    this.siteEditorConfig.next(this.siteEditorConfigInit);
    if(this.siteMetas.length > 1){
      let firstId = this.siteMetas[0].siteId;
      this.siteMetas.forEach(meta => {
        if(meta.siteId != firstId){
          let endpoint = "website/"+meta.siteId;
          this.ofbizForms.doGetWebSite(endpoint)
          .pipe(take(1))
          .subscribe(resp => {
            let site = (resp["data"]);
            console.log(site);
            let keeper = _.cloneDeep(site);
            site.pages.splice(0,site.pages.length);
            keeper.pages.forEach(page => {
              site.pages.push(new Page(page));
            })
            this.siteEditorConfigInit.sites.push(site);
          })
        }

      }
    )
    this.siteEditorConfig.next(this.siteEditorConfigInit);
  } */





}
